import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextAreaInput from '../TextAreaInput';
import YesNoInput from '../YesNoInput';
import './YesNoDescriptionInput.scss';
var getValueField = function getValueField(option, value, field) {
  var optionValue = value && value.find(function (v) {
    return v.id === option.id;
  });
  return optionValue && optionValue[field];
};
var YesNoDescriptionInput = /*#__PURE__*/function (_Component) {
  function YesNoDescriptionInput(props) {
    var _this;
    _classCallCheck(this, YesNoDescriptionInput);
    _this = _callSuper(this, YesNoDescriptionInput, [props]);
    _this.onOptionValueChange = _this.onOptionValueChange.bind(_this);
    return _this;
  }
  _inherits(YesNoDescriptionInput, _Component);
  return _createClass(YesNoDescriptionInput, [{
    key: "onOptionValueChange",
    value: function onOptionValueChange(option, key, newVal) {
      var _this$props = this.props,
        value = _this$props.value,
        onAnswerChange = _this$props.onAnswerChange;
      var currentOptionValue = value.find(function (v) {
        return v.id === option.id;
      });
      if (currentOptionValue) {
        // Replace the option value
        var others = value.filter(function (v) {
          return v.id !== option.id;
        });
        onAnswerChange([].concat(_toConsumableArray(others), [_objectSpread(_objectSpread({}, currentOptionValue), {}, _defineProperty({}, key, newVal))]));
        return;
      }

      // Append the option value
      onAnswerChange([].concat(_toConsumableArray(value), [_defineProperty({
        id: option.id,
        selected: null,
        desc: ''
      }, key, newVal)]));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        formKey = _this$props2.formKey,
        index = _this$props2.index,
        option = _this$props2.option,
        value = _this$props2.value,
        exampleText = _this$props2.exampleText,
        selectedValue = _this$props2.selectedValue,
        descRequired = _this$props2.descRequired,
        error = _this$props2.error,
        textAreaPrompt = _this$props2.textAreaPrompt;
      var id = option.id,
        name = option.name,
        description = option.description;
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        className: "mb-4 ".concat(formKey).concat(id ? "-".concat(id) : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "option-container body-text-2 medium-weight"
      }, error && error === 'radio_button' && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight with-error-text mb-2"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), ' ', "Required!"), /*#__PURE__*/React.createElement("div", {
        className: "option-text mb-15 ".concat(error && error === 'radio_button' && 'with-error-text')
      }, index, ".", name || description), /*#__PURE__*/React.createElement(YesNoInput, {
        className: "yes-no-container mb-15 ms-3",
        id: "".concat(formKey).concat(id || ''),
        value: selectedValue,
        onAnswerChange: function onAnswerChange(val) {
          return _this2.onOptionValueChange(option, 'selected', val);
        }
      })), selectedValue && /*#__PURE__*/React.createElement("div", {
        className: "ms-2"
      }, error && error === 'field' && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight with-error-text mb-2"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), ' ', "Required!"), /*#__PURE__*/React.createElement(TextAreaInput, {
        placeholder: descRequired ? 'Tell us more... (required)' : 'Tell us more...',
        required: descRequired,
        error: error,
        value: getValueField(option, value, 'desc'),
        onAnswerChange: function onAnswerChange(val) {
          return _this2.onOptionValueChange(option, 'desc', val);
        },
        exampleText: exampleText,
        textPromptClass: error && 'with-error-text',
        textAreaPrompt: textAreaPrompt
      })));
    }
  }]);
}(Component);
YesNoDescriptionInput.propTypes = {
  formKey: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  option: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    selected: PropTypes.string,
    desc: PropTypes.string
  })),
  onAnswerChange: PropTypes.func.isRequired,
  exampleText: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
  descRequired: PropTypes.bool,
  error: PropTypes.string,
  textAreaPrompt: PropTypes.string
};
YesNoDescriptionInput.defaultProps = {
  value: [],
  exampleText: null,
  descRequired: false,
  error: '',
  textAreaPrompt: 'Tell us more about that.'
};
export default YesNoDescriptionInput;